import React, { FunctionComponent } from 'react';
import {ReactComponent as LeftIcon} from '@iba-team/portal-react-components/dist/svg/outline/chevron-left.svg';
import {ReactComponent as RightIcon} from '@iba-team/portal-react-components/dist/svg/outline/chevron-right.svg';
import './ArrowButtons.scss';
import { SegmentedItem } from '@iba-team/portal-react-components/dist';

interface ArrowButtonsI {
  onLeftClick: () => void,
  onRightClick: () => void,
}

export const ArrowButtons: FunctionComponent<ArrowButtonsI> = (props) => {
  const { onLeftClick, onRightClick } = props;
  return (<div className={'arrowButtons'}>
    <SegmentedItem onClick={() => onLeftClick()}>
      <LeftIcon/>
    </SegmentedItem>
    <SegmentedItem onClick={() => onRightClick()}>
      <RightIcon/>
    </SegmentedItem>
  </div>);
};
